import { render, staticRenderFns } from "./ReSearchCardPlanHelp.vue?vue&type=template&id=2ac31e9c&scoped=true"
import script from "./ReSearchCardPlanHelp.vue?vue&type=script&lang=js"
export * from "./ReSearchCardPlanHelp.vue?vue&type=script&lang=js"
import style0 from "./ReSearchCardPlanHelp.vue?vue&type=style&index=0&id=2ac31e9c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ac31e9c",
  null
  
)

export default component.exports